import React, { useContext, useEffect } from 'react';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import AddItem from '../../../shared/Domains/AddItem';
import { TabDescription } from '../../../shared/TabDescription/TabDescription';
import Item from '../../../shared/Domains/Item';

const DomainsTab = ({ data, onChange }) => {
  const context = useContext(AppContext);
  const { dispatch } = context;

  useEffect(() => {
    if (!('domains' in data) || !data.domains) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'domains',
          value: {
            enable: true,
            heading: 'Domains',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    <>
      <div className="mb23 flex justify-between items-center">
        <div className="title_tab">Domains</div>

        <div className="col-span-1">
          <Checkbox
            checked={data.domains?.enable}
            onChange={v => onChange('data.domains.enable', v)}
          />
        </div>
      </div>

      <TabDescription tab={'domains'} />

      {data.domains?.items?.map((x, index) => (
        <Item
          item={x}
          key={x.id}
          index={index}
          dispatch={dispatch}
          first={index === 0}
          last={index === data.domains?.items.length - 1}
        />
      ))}

      <AddItem dispatch={dispatch} domains={data.domains?.items} />
    </>
  );
};

export default DomainsTab;
